export default __webpack_public_path__ + "static/img-afterparty-2019-516f58a862b4c2fb18a6256c3ec7ba2d.png";